export default __webpack_public_path__ + "static/media/setup.b100143a.png";